module.exports = "<div class='row'>\r\n  <div class='medium-12 columns'>\r\n    <h1>Guidr - CMS</h1>\r\n  </div>\r\n</div>\r\n\r\n<div class='row'>\r\n  <div class='medium-12-columns'>\r\n    <button id='submit' class='tiny'>Save</button>\r\n    <span id='valid_indicator' class='label'></span>\r\n  </div>\r\n</div>\r\n<div class='row'>\r\n  <div id='editor_holder' class='medium-12 columns'></div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/muth/Documents/privat/angular/guidr/src/app/components/cms/cms.component.html
// module id = ../../../../../src/app/components/cms/cms.component.html
// module chunks = main